const header = {
  systemTitle: 'Injection Molding Control System',
  logoAlt: 'Logo',
  notice: 'Notices',
  noticeEmpty: 'No notices',
  noticeCount: '{count}',
  noticeBadge: {
    urgent: 'Urgent',
    update: 'Update',
    notice: 'Notice',
    general: 'General',
  },
  alarmStatus: 'Alarm Status',
  alarmCount: '{count}',
  alarmLoading: 'Loading alarms...',
  alarmNone: 'No alarms',
  noticeAll: 'View all notices',
  noticeViews: '{count} views',
  bell: 'Notification center',
  ticker: {
    count: '{sev} {count}',
    prev: 'Previous alarm',
    next: 'Next alarm',
    list: 'Open notification center',
    openDetail: 'Open alarm detail',
  },
  toast: {
    detail: 'Equipment detail',
    ack: 'Acknowledge',
  },
  center: {
    title: 'Notification Center',
    unread: 'Unread {count}',
    subtitle: 'All alarms · click a row to open the detail',
    all: 'All {count}',
    unreadChip: 'Unread {count}',
    severityAll: 'All severities',
    ackAll: 'Acknowledge all',
    history: 'Full history',
    acked: 'Acknowledged',
    empty: 'No alarms to show',
    ackNote: 'Acknowledge and mute states are saved in this browser only (no server API)',
  },
  detail: {
    position: '{sev} {i} of {n}',
    prev: 'Prev',
    next: 'Next alarm',
    list: 'All alarms',
    cause: 'Cause',
    codeLabel: 'Alarm code {code}',
    typeLabel: 'Type {type}',
    indicators: 'Indicators',
    indicatorNote: 'Latest shot (not the value at alarm time)',
    maxPressure: 'Max inj. pressure',
    cushion: 'Cushion position',
    cycleTime: 'Cycle time',
    quick: 'Quick actions',
    ack: 'Acknowledge (ACK)',
    acked: 'Acknowledged',
    mute: 'Mute 30 min',
    muted: 'Muted until {time}',
    goEquipment: 'Go to equipment · alarm tab',
    askAi: 'Ask AI for the cause',
    alarmId: 'Alarm ID {id}',
    history: 'Full history',
    timeAgoAt: '{time} ({ago})',
    askQuestion: 'Explain the cause of alarm "{message}" (code {code}) on {equipment} and how to fix it',
  },
  ai: {
    fab: 'Ask',
    title: 'AI Assistant',
    openFull: 'Open full analysis',
    context: 'Context',
    empty: 'Ask anything about the shop-floor data',
    suggestionsTitle: 'Suggested questions (this screen)',
    q1: 'Which machine had the most alarms in the last 24 hours?',
    q2: 'Which machine has the highest defect rate today?',
    q3: 'How many machines are running right now?',
    placeholder: 'Ask in plain shop-floor terms…',
    send: 'Send',
    thinking: 'Thinking…',
    failed: 'Could not reach the AI service',
    noAnswer: 'No answer was produced',
    newChat: 'New chat',
    newChatHint: 'Clear this conversation and start over',
  },
  collection: {
    loading: 'Checking...',
    title: 'Data Collection Status',
    factoryCount: '{count} factories',
    statusNoEquipment: 'No equipment',
    stoppedBadge: '{count} stopped',
    allNormal: 'Data is being collected normally from all equipment',
    empty: 'No factories registered',
    countRunning: 'Running',
    countIdle: 'Idle',
    countStopped: 'Stopped',
    neverCollected: 'Never collected',
    elapsedMin: '{n} min ago',
    elapsedHour: '{n} hr ago',
    elapsedDay: '{n} days ago',
  },
};

export default header;
